var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { TextVariants, Colors } from "../../theme/enums";
import { Flex } from "theme-ui";
import { Fragment } from "react";
export const ProductPrice = (_a) => {
    var { price, discountPrice, sx } = _a, props = __rest(_a, ["price", "discountPrice", "sx"]);
    return (_jsx(Flex, Object.assign({ sx: Object.assign({ flexGrow: 1, flexShrink: 1, flexDirection: "row" }, sx) }, props, { children: discountPrice ? (_jsxs(Fragment, { children: [_jsx("span", { sx: {
                        variant: `text.${TextVariants.label2}`,
                        display: "inline-block",
                        textDecoration: "line-through"
                    }, children: price }), _jsx("span", { sx: {
                        variant: `text.${TextVariants.label2}`,
                        display: "inline-block",
                        ml: 8,
                        color: `${Colors.red}.0`
                    }, children: discountPrice })] })) : (_jsx("span", { sx: { variant: `text.${TextVariants.label2}`, color: Colors.muted }, children: price })) })));
};
//# sourceMappingURL=ProductPrice.js.map